import { render, staticRenderFns } from "./EditionSelect.vue?vue&type=template&id=def833e8&"
import script from "./EditionSelect.vue?vue&type=script&lang=js&"
export * from "./EditionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports